var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14179_519)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14179_519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 9.99996C18.3333 14.6023 14.6023 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6023 1.66667 9.99996C1.66667 5.39758 5.39763 1.66663 10 1.66663C14.6023 1.66663 18.3333 5.39758 18.3333 9.99996ZM9.99751 7.34939C9.69925 7.34939 9.44351 7.25085 9.23051 7.05376C9.01742 6.85667 8.91084 6.61963 8.91084 6.34264C8.91084 6.06566 9.01742 5.82862 9.23051 5.63153C9.44351 5.43444 9.69925 5.3359 9.99751 5.3359C10.2985 5.3359 10.5542 5.43444 10.7646 5.63153C10.9776 5.82862 11.0842 6.06566 11.0842 6.34264C11.0842 6.61963 10.9776 6.85667 10.7646 7.05376C10.5542 7.25085 10.2985 7.34939 9.99751 7.34939ZM8.89492 14.125V8.40529H11.1002V14.125H8.89492Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14179_519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#535353"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14179_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.46d3d7317e7751f9a867c4e1002ed4dc.svg";
export { ForwardRef as ReactComponent };